<template>
  <su-page title="查询结果页">
    <el-row class="mt30" slot="content">
      <el-form
          :model="queryParams"
          ref="queryForm"
          size="small"
          :inline="true"
          label-width="68px">
        <el-form-item label="姓名" prop="name">
          <el-input
              v-model="queryParams.name"
              placeholder="姓名"
              clearable
              @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="证件号码" prop="cert_no">
          <el-input
              v-model="queryParams.cert_no"
              placeholder="请输入"
              clearable
              @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
          <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
      <div class="mt20" v-if="tableData && tableData.length > 0">
        <el-table :data="tableData" style="width: 100%" :header-cell-style="{backgroundColor:'#F3F4F8'}">
          <el-table-column prop="name" label="姓名"></el-table-column>
          <!-- <el-table-column prop="account" label="账号"></el-table-column>-->
          <!-- <el-table-column prop="date" label="日期"></el-table-column>-->
          <el-table-column prop="exam_time" label="考试时间"></el-table-column>
          <el-table-column prop="address" label="地点"></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button v-if="scope.row.image" type="primary" size="small" @click="downloadPicture(scope.row.image)">下载</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--<el-image style="width: 290px;height: 204px;" :src="url"></el-image>
          <el-row class="mt20">
          </el-row>-->
      </div>
      <el-empty v-else-if="token" :image-size="100" description="暂无证书"></el-empty>
    </el-row>
  </su-page>
</template>
<script>

import {getCert} from "@/api/api";
import {mapState} from 'vuex'

export default {
  name: "certificateQuery",
  data() {
    return {
      // 列表加载
      loading: false,
      // 查询参数
      queryParams: {
        name: '',
        cert_no: '',
      },
      tableData: [],
      url: '',
      pdf: '',
    }
  },
  computed: {
    ...mapState(['token', 'userInfo']),
  },
  created() {

  },
  mounted() {
    this.getCert()
  },
  methods: {
    downloadPicture(url) {
      // window.open(url)
      const link = document.createElement('a');
      link.href = url;
      link.download = 'document.pdf';

      // 模拟点击下载
      link.click();
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.getCert();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 重置表单
    resetForm(formName) {
      this.$refs[formName].clearValidate(); //清除验证
      this.$refs[formName].resetFields(); //重置表单
    },
    // 证书查询
    getCert() {
      this.loading = true;
      getCert(this.queryParams).then(response => {
        if (response.status === 200) {
          this.tableData = response.data || [];
        }
        this.loading = false;
      }).then(error => {
        this.loading = false;
      });
    },
  }
}
</script>


<style scoped lang="scss">

</style>
